/**
 * In-memory store for the RSA public key served by monosan's
 * `POST /api/auth/refresh`. Populated on boot (see `features/auth/api/refresh`)
 * before any credential payload is encrypted. Never hardcoded or persisted.
 */
let publicKey: string | null = null

export const publicKeyStore = {
  get: (): string | null => publicKey,
  set: (key: string): void => {
    publicKey = key
  },
  clear: (): void => {
    publicKey = null
  },
}

// Base64 (X.509 SubjectPublicKeyInfo) key used to encrypt credential payloads.
// Throws if called before the boot refresh populated the store.
export const getPublicKey = (): string => {
  if (!publicKey) {
    throw new Error('Public key unavailable: refresh must run before encrypting')
  }
  return publicKey
}
